import { LocalStorage } from '../../models/LocalStorage';
import { getParamUrl } from '../../utils/utils';

const $ = window.$;
var maxStep = 0;
const MIN_HEIGHT = 600;
const STEP_CONTENT = {
    NORMAL: {
        title: 'Welcome to <span style="font-weight: bold;">Dutycast!</span>',
        content: 'Instantly calculate tax, access to the up-to-date trade statistics report, and get the most relevant documents on any procedures or regulations required.'
    },
    COMPLETE: {
        title: '<span style="font-weight: bold;">Thanh you!</span>',
        content: 'The report will be sent to your inbox shortly.<br/>If you do not find the email in Primary Inbox , please check the Spam Folder.'
    }
}
const initViewFollowByScreen = () => {
    if ($('.walkthrough.open').length > 0) {
        if ($(window).height() > MIN_HEIGHT) {
            $('.walkthrough-container').css('margin-top', '')
            $(window).scrollTop(250);
        } else {
            $('.walkthrough-container').css('margin-top', '20px')
            $(window).scrollTop(420);
        }
    }
}
export const setUpWalkthrough = (search) => {
    if ($(window).width() > 1199) {
        $(document).ready(function () {
            var wt = isWalkthrogh();
            const param = getParamUrl();
            if ((!wt || (wt !== 'skip' && wt !== '4')) && (!param.hs || !param.export || !param.destination)) {
                // window.setTimeout(() => {
                //     startWalkthroughDecision();
                //     initViewFollowByScreen();
                // }, 1000);
            }
            $('.step-wrapper .step-index').on('click', function (e) {
                var step = $(this).attr('step');

                if (step <= maxStep) {
                    if (parseInt(step) === 4) {
                        $(window).scrollTop(0);
                        $('.walkthrough').removeClass('uncomplete');
                        $('.walkthrough-section').removeClass('uncomplete');
                        if ($('.laststep-form').find('.sendMeEmail-form').length === 0) {
                            $('.sendMeEmail-form').find('button').html('Go')
                            $('.laststep-form').append($('.sendMeEmail-form'));
                        }
                    } else {
                        $('.step-wrapper').attr('step', step)
                        $('.walkthrough-section').attr('step', step)
                        initWalkthroughView();
                        switch (parseInt(step)) {
                            case 1:
                                $('.destination-country select')[0].selectize.open();
                                break;
                            case 2:
                                $('.product input').focus();
                                break;
                            case 3:
                                $('.export-country select')[0].selectize.open();
                                break;
                            default:
                                break;
                        }
                    }
                }
            });
        })
        $('.product input.form-control').on('focus', function () {
            setStep(2);
        })
        $('.btn-start').on('click', function () {
            setStep(1);
            startWalkthrough();
        })
        $('.skip').on('click', function () {
            const step = $('.walkthrough').attr('step');
            stopWalkthrough(true);
            if (step === "4" && typeof search === 'function') {
                search();
            }
        })
        $(window).resize(function () {
            initViewFollowByScreen();
        })
    }
}

export const setStep = (step) => {
    if (step >= maxStep) {
        maxStep = step;
    }
    $('.step-wrapper').attr('step', step);
    $('.walkthrough').attr('step', step);
    $('.walkthrough-section').attr('step', step)
    if (parseInt(step) === 4) {
        $(`.step-wrapper .step-index[step="${4}"]`).trigger('click');
    }
}

export const isWalkthrogh = () => {
    return LocalStorage.getWalkThrought();
}
export const stopWalkthrough = (isSkip = false) => {
    $('.walkthrough').removeClass('open');
    $('.walkthrough-section').removeClass('open');
    $('body').css('overflow', '');
    if ($('.sendMeEmail-form-wrapper').find('.sendMeEmail-form').length === 0) {
        $('.sendMeEmail-form').find('button').html('Submit')
        $('.sendMeEmail-form-wrapper').append($('.sendMeEmail-form'));
    }
    $('.walkthrough-section').css('margin-top', '');
    if (isSkip) {
        LocalStorage.setWalkThrought('skip');
    } else {
        LocalStorage.setWalkThrought($('.walkthrough').attr('step'));
    }
    $(window).scrollTop(0);
}
export const initWalkthroughView = (isFirst = false) => {
    console.log({ maxStep })
    if (maxStep === 4) {
        maxStep = 3;
    }
    $('body').css('overflow', 'hidden');
    if ($('.header-detail')[0].style.display !== 'none') {
        initViewFollowByScreen();
    } else {
        $('.walkthrough-section').css('margin-top', '250px');
        setTimeout(() => {
            $(window).scrollTop(0);
        }, 300);
    }
    $('.walkthrough').addClass('open').addClass('uncomplete');
    $('.walkthrough-section').addClass('open').addClass('uncomplete');
    if (isFirst) {
        setTimeout(() => {
            $('.step-wrapper .step-index[step="1"]').trigger('click');
        }, 300);
    }
}
export const startWalkthroughDecision = () => {
    setStep(0);
    $('.walkthrough').addClass('open').addClass('uncomplete');
    $('body').css('overflow', 'hidden');
}
export const startWalkthrough = () => {
    initWalkthroughView(true);
    LocalStorage.setWalkThrought('0');
    // if (getParamUrl('export', window.location.href)) {
    if (getParamUrl('destination', window.location.href)) {
        maxStep = 4;
    }
}

const setFormContent = (step) => {
    $('.walkthrough-title').html(step.title);
    $('.walkthrough-description').html(step.content);
}

export const responseForm = (callBack) => {
    if (!window.isDetail) {
        setFormContent(STEP_CONTENT.COMPLETE)
        // window.setTimeout(() => {
        stopWalkthrough();
        $('.go-button .btn').trigger('click');
        // }, 1500);
    }
}